<template>
  <div class="flex w-full items-center justify-between">
    <span class="text-headline">
      {{ capitalize(modelValue) }}
    </span>
    <icon-base v-if="isSelected" :icon="IconSent" class="text-blue-500" />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import capitalize from "lodash/capitalize";

import IconSent from "@/components/icons/email/IconSent.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { NoteType } from "@/enums/dealActivity";

interface Props {
  modelValue: NoteType;
  selected: NoteType[];
}

const { modelValue, selected } = defineProps<Props>();

const isSelected = computed(() => !!selected?.includes(modelValue));
</script>
